import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@heroui/react";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { apiRoute, ENUM_PAGEACTION_TYPE, linksUrl } from "../../constants/enum";
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components";
import { COLUMN_ALIGN_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable";
import { toast } from "react-toastify";
import ConfirmBox from "../../components/ConfirmBox";
import { setDetailParams, setNewEntryMode } from "../../state/flrnSlice";

const FlrnMaster = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);

    // State for confirmation modal
    const [itemToDelete, setItemToDelete] = useState("")
    const [itemToEdit, setItemToEdit] = useState("")
    const [pageActionType, setPageActionType] = useState("")

    // Fetch cut data
    const {
        data: flrnData = [],
        isPending,
        isError,
        mutate: filterData,
    } = usePost({
        url: apiRoute.flrn.getFlrn,
        queryKey: "fetchFlrnMaster",
    });
    const funLoadData = () => {
        filterData({
            data: {}
        })
    }
    useEffect(() => {
        funLoadData();
    }, [])
    const sortedFlrnData = [...flrnData].sort((a, b) => a.Flrn_Ord - b.Flrn_Ord);


    const onSuccessDelete = (data) => {
        if (data && data.length > 0) {
            if (data[0].ref == 1) {
                toast.error("Flrn can't be delete as it locked", {
                    position: "top-center",
                    "className": "toast-error",
                })
            }
            else {
                setItemToDelete("")
                funLoadData();
            }


        }
    };

    // Delete cut mutation
    const { mutate: deleteflrn } = usePost({
        url: apiRoute.flrn.deleteFlrn,
        queryKey: "deleteFlrnMaster",
        onSuccessTasks: onSuccessDelete,
      //  successMessage: "flrn deleted successfully!",
    });

    // Open confirmation box
    // const handleDeleteClick = (Flrn_Code) => {
    //     if (!Flrn_Code) {
    //         toast.error("Error: Flrn CODE is missing.");
    //         return;
    //     }
    //     else
    //         setItemToDelete(Flrn_Code);
    // };

    // const handleConfirmBox = (confirm) => {
    //     if (confirm && itemToDelete) {
    //         deleteflrn({ data: { Flrn_Code: itemToDelete } });
    //     }
    //     else
    //         setItemToDelete("");
    // };
     const handleConfirmBox = (data) => {
        if (data) {
            if (itemToDelete && itemToDelete != null) {
                deleteflrn({ data: { Flrn_Code: itemToDelete } });
            }
            else if (itemToEdit != "" & itemToEdit != null && Object.keys(itemToEdit).length > 0) {
                {
                 dispatch(setDetailParams(itemToEdit));
                 dispatch(setNewEntryMode(false))
                navigate(linksUrl.diamondParamater.flrn.createFlrnMaster);
                }
            }
        }
        else {
            setItemToEdit("")
            setItemToDelete("")
            setPageActionType("")
        }
    };

    const handleAddNew = () => {
        dispatch(setNewEntryMode(true));
        dispatch(setDetailParams([]));
        navigate(linksUrl.diamondParamater.flrn.createFlrnMaster);
    };
    const exportColumns = [
        { uid: "Flrn_Code", name: "Flrn Code" }, { uid: "Flrn_Name", name: "Flrn Name" }, { uid: "Flrn_Group", name: "Flrn Name" }, { uid: "Flrn_Ord", name: "Flrn Ord" }
    ]

    const downloadDataFooter = {
        Flrn_Code: "", Flrn_Name: "", Flrn_Group: "", Flrn_Ord: ""
    }
    const columns = [
        { name: "Actions", uid: "actions", align: COLUMN_ALIGN_TYPE.center },
        { name: "Flrn_Code", uid: "Flrn_Code", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Flrn_Name", uid: "Flrn_Name", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Flrn_Group", uid: "Flrn_Group", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Flrn_Ord", uid: "Flrn_Ord", sortable: true, align: COLUMN_ALIGN_TYPE.center },
    ];

    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon icon={faEdit} style={{ color: "#379906" }} />,
            onClick: (row) => {
                setItemToDelete("")
                let obj = {
                    Flrn_Code: row.Flrn_Code
                };
                setItemToEdit(obj)
                setPageActionType(ENUM_PAGEACTION_TYPE.Edit)
                // dispatch(setDetailParams(obj));
                // dispatch(setNewEntryMode(false))
                // navigate(linksUrl.diamondParamater.flrn.createFlrnMaster);
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon icon={faTrash} style={{ color: "#c40c18" }} />,
            onClick: (row) => {
                setItemToEdit("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Delete)
                setItemToDelete(row?.Flrn_Code);
                // handleDeleteClick(row.Flrn_Code);
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
    ];

    if (isPending) return <LoadingCard />;
    if (isError) return <ErrorCard />;

    return (
        <div>
            <MainContainer pageName="Flrn" breadcrumbs={["Diamond Parameter", "Flrn Master"]}>
                <div className="text-right mb-4">
                    <Button size="sm" color="primary" startContent={<FontAwesomeIcon icon={faPlus} />} onPress={handleAddNew}>
                        Add New
                    </Button>
                </div>
                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={["actions", "Flrn_Code", "Flrn_Name", "Flrn_Group", "Flrn_Ord"]}
                    data={sortedFlrnData}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    downloadDataFooter={downloadDataFooter}
                    exportColumns={exportColumns}
                    downloadFileName="flrn-master-List"
                    showAdvanceFilter={false}
                    id="Flrn_Code"

                />
            </MainContainer>

            {(itemToDelete || itemToEdit) && (
                <ConfirmBox
                    handleConfirmBox={handleConfirmBox}
                    actionType={pageActionType}
                />
            )}
        </div>
    );
};

export default FlrnMaster;
